import { render } from "./FavouritesPage.vue?vue&type=template&id=709869dd"
import script from "./FavouritesPage.vue?vue&type=script&lang=js"
export * from "./FavouritesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__